import { asset } from "@/lib/asset";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState, useEffect } from 'react';

const partners = [
    { id: 1, image: asset('/img/partners/sber.png'), alt: 'Сбер' },
    { id: 2, image: asset('/img/partners/vtb.png'), alt: 'ВТБ' },
    { id: 3, image: asset('/img/partners/rostec.png'), alt: 'Ростелеком' },
    { id: 4, image: asset('/img/partners/mkb-investment.png'), alt: 'МКБ Инвестиции' },
    { id: 5, image: asset('/img/partners/mkb.png'), alt: 'МКБ' },
    { id: 6, image: asset('/img/partners/rosbank.png'), alt: 'Росбанк' },
    { id: 7, image: asset('/img/partners/roccet.png'), alt: 'Россети' },
    { id: 8, image: asset('/img/partners/komus.png'), alt: 'Комус' },
    { id: 9, image: asset('/img/partners/vinlab.png'), alt: 'Винлаб' },
    { id: 10, image: asset('/img/partners/evraz.png'), alt: 'Евраз' },
    { id: 11, image: asset('/img/partners/otkritiye.png'), alt: 'ОТКРИТИЕ' },
    { id: 12, image: asset('/img/partners/rocelbank.png'), alt: 'Россельхозбанк' },
    { id: 13, image: asset('/img/partners/icon-x.png'), alt: '' }
];

export default function PartnersSlides() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [swiperInstance, setSwiperInstance] = useState(null);
    const [slidesPerView, setSlidesPerView] = useState(1);

    // Calculate total number of dots needed
    const totalSlides = Math.ceil(partners.length / slidesPerView);

    // Update slidesPerView when window size changes
    useEffect(() => {
        const updateSlidesPerView = () => {
            const width = window.innerWidth;
            if (width >= 1536) setSlidesPerView(8);      // 2xl
            else if (width >= 1280) setSlidesPerView(6); // xl
            else if (width >= 1024) setSlidesPerView(4); // lg
            else if (width >= 768) setSlidesPerView(3);  // md
            else setSlidesPerView(1);                    // mobile
        };

        updateSlidesPerView();
        window.addEventListener('resize', updateSlidesPerView);
        return () => window.removeEventListener('resize', updateSlidesPerView);
    }, []);

    return (
        <div className="container mx-auto px-4">
            <div className="flex flex-col xl:hidden">
            <div className="flex items-center justify-center h-full">
                <button className="swiper-button-prev !w-10 !h-10 !static flex items-center justify-center !text-gray-600 [&>svg]:!w-6 [&>svg]:!h-6">
                </button>
                
                <Swiper
                    onSwiper={setSwiperInstance}
                    onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                    modules={[Navigation, Autoplay]}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    slidesPerView={slidesPerView}
                    spaceBetween={30}
                    breakpoints={{
                        // md
                        768: {
                            slidesPerView: 3,
                            slidesPerGroup: 1,
                        },
                        // lg
                        1024: {
                            slidesPerView: 4,
                            slidesPerGroup: 1,
                        },
                        // xl
                        1280: {
                            slidesPerView: 5,
                            slidesPerGroup: 1,
                        },
                        // 2xl
                        1536: {
                            slidesPerView: 7,
                            slidesPerGroup: 1,
                        },
                    }}
                    className="w-full h-auto xl:h-[180px]"
                >
                    {partners.map((partner) => (
                        <SwiperSlide key={partner.id} className="py-12 px-auto flex items-center justify-center align-center">
                            
                            <div className=" mx-auto flex items-center px-[5px] justify-center align-center w-16 h-16 left-0 top-0 xl:top-[1px] bg-white rounded-lg shadow-[0px_2px_4px_1px_#CAA98C]">
                            <img
                                src={partner.image}
                                alt={partner.alt}
                                className="w-auto object-contain"
                            />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <button className="swiper-button-next !w-10 !h-10 !static flex items-center justify-center !text-gray-600 [&>svg]:!w-6 [&>svg]:!h-6">
                </button>
                </div>

                {/* Bottom navigation buttons */}
                <div className="flex justify-center mt-[4px] xl:mt-[-25px] gap-2 xl:gap-[50px] xl:h-[20px] hidden xl:flex">
                    {[...Array(totalSlides)].map((_, index) => (
                        <button 
                            key={index}
                            className={`w-full xl:w-[14px] h-auto xl:h-[14px] flex items-center justify-center border border-gray-300 rounded-full ${
                                Math.floor(activeIndex / slidesPerView) === index ? 'bg-[#ffb805]' : 'bg-[#D9D9D9]'
                            }`}
                            onClick={() => swiperInstance?.slideTo(index * slidesPerView)}
                        >
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
